export default __webpack_public_path__ + "static/media/DocuWareLogBig.460f3a57.svg";